/**
 * Ouvre une page du site connecté en tant qu'administrateur (#180).
 *
 * Partagé par tous les liens du CMS vers le site — « Voir le site », « Voir la
 * page », la liste des thèmes, la recherche — pour qu'ils montrent tous ce
 * que voit un adhérent, contenu réservé compris, et non la page d'un visiteur.
 *
 * L'onglet est ouvert **avant** l'appel : un `window.open` qui suit un `await`
 * n'est plus rattaché au clic, et les navigateurs le bloquent comme une
 * fenêtre surgissante. Il reçoit son adresse une fois le code obtenu.
 *
 * Sans droit d'administrateur, ou si l'appel échoue, la page s'ouvre en
 * simple visiteur : le lien garde au moins son usage d'avant.
 */
export function useSiteEnAdmin() {
  const base = String(useRuntimeConfig().public.sitePublicUrl || '').replace(/\/+$/, '')

  /** `url` : adresse complète sur le site, telle que les écrans la calculent déjà. */
  async function ouvrirSurLeSite(url: string = base || '/') {
    const onglet = window.open('about:blank', '_blank')
    let destination = url

    const chemin = base && url.startsWith(base) ? (url.slice(base.length) || '/') : '/'

    try {
      // Signature déclarée, comme dans `stores/auth.ts` : l'inférence des
      // routes de `$fetch` épuise ici la profondeur d'instanciation (TS2589).
      const demander = $fetch as unknown as (
        route: string,
        options: { method: 'POST', body: { chemin: string } },
      ) => Promise<{ url: string }>
      destination = (await demander('/api/admin/site-session', { method: 'POST', body: { chemin } })).url
    }
    catch {
      // Repli sur la page publique, sans session.
    }

    if (!onglet) {
      window.open(destination, '_blank', 'noopener')
      return
    }

    // Coupe le lien vers l'admin site, comme le faisait `rel="noopener"`.
    onglet.opener = null
    onglet.location.href = destination
  }

  return { ouvrirSurLeSite }
}
